import React, { useState, useEffect } from 'react'
import '../../assets/styles/dashboard.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import commonService from '../../services/otherServices';
import Pagination from '../../components/Common/Pagination';
import Advertisment from '../../components/Common/Advertisment';
import EditableListName from "./EditableListName";
import Popup from '../../components/Common/Error'
import axios, { AxiosError } from "axios";

const Dashboard = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [showUpdatePopup, setShowUpdatePopup] = useState(false);
    // const [showAvailPopup, setShowAvailUpdatePopup] = useState(false);
    // const [showContactPopup, setShowContactUpdatePopup] = useState(false);
    const [isListLoading, setIsListLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [downloads, setDownloads] = useState<any[]>([]);
    const [item, setItem] = useState<any>(null);
    const [errorMsg, setErrorMsg] = useState("");
    const [showDownloadConfirm, setShowDownloadConfirm] = useState(false);
    const [selectedFormat, setSelectedFormat] = useState<"csv" | "xlsx">("csv");
    const [selectedItem, setSelectedItem] = useState<any>(null);
    const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");


    const [pageDetail, setPageDetail] = useState({
        page: 1,
        total_pages: 1,
        total_records: 0,
        page_size: 5,
    });

    useEffect(() => {
        loadPage(1);
    }, []);

    const loadPage = async (page: number, order: "asc" | "desc" = sortOrder) => {
        if (isListLoading) return;
        setDownloads([]);
        try {
            setIsListLoading(true);

            const payload = {
                page,
                page_size: pageDetail.page_size,
                sort_by: "created_at",
                order: order,
            };

            const response = await commonService.loadProjectList(payload);

            let items = response?.data?.items || [];
            // Sort items based on created_at
            items.sort((a: any, b: any) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);
                if (order === "asc") {
                    return dateA.getTime() - dateB.getTime();
                } else {
                    return dateB.getTime() - dateA.getTime();
                }
            });

            setDownloads(items);
            setPageDetail({
                page: response.data.page,
                total_pages: response.data.total_pages,
                total_records: response.data.total,
                page_size: response.data.page_size,
            });
        } catch (error) {
            console.error("Error fetching email verify list:", error);
        } finally {
            setIsListLoading(false);
        }
    }

    const toggleSort = () => {
        const newOrder = sortOrder === "asc" ? "desc" : "asc";
        setSortOrder(newOrder);
        loadPage(pageDetail.page, newOrder);
    }

    const downloadProject = async (item: any, format: "csv" | "xlsx") => {
        setShowPopup(true);
        try {
            const response = await commonService.downloadProject(item.projectid, format);

            if (!response || response?.data?.status === "failed") {
                setErrorMsg("Failed to download the project.");
                return;
            }

            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `${item.list_name}.zip`;
            link.click();

            window.URL.revokeObjectURL(url);
            setShowSuccessPopup(true);

        } catch (err) {
            setErrorMsg("Something went wrong");
        } finally {
            setShowPopup(false);
        }
    };


    const updateProject = async (item: any) => {
        try {
            setIsLoading(true);
            const response = await commonService.updateProjectRequest(item.projectid);
            if (!response || response?.data?.status === 'failed') {
                setErrorMsg('Failed to send a update request.');
                return;
            }
            setIsLoading(false)
            setShowUpdatePopup(true);
        } catch (err) {
            let errorMessage = 'Something went wrong';

            if (err instanceof Error) {
                errorMessage = err.message;
            } else if (typeof err === 'string') {
                errorMessage = err;
            }
            setIsLoading(false)
            setErrorMsg(errorMessage);
        } finally {
            setIsLoading(false)
        }
    }

    const openCriteriaPopup = (item: any) => {
        console.log("item", item);
        setItem(item)
        setIsOpen(true)
    }

    const isOlderThan90Days = (createdAt: string | Date): boolean => {
        const createdDate = new Date(createdAt);
        const now = new Date();

        const diffInDays =
            (now.getTime() - createdDate.getTime()) / (1000 * 60 * 60 * 24);

        return diffInDays >= 90;
    };

    return (
        <>
            <div className="container">
                <Advertisment />
                <div>
                    <p className="your-data">Your Data Requests Overview</p>
                    <p className="track">Track your submitted data requests, download completed lists, or refresh older datasets for the latest updates.</p>
                </div>

                <div>
                    <div className="dashboard-table-wrapper">
                        <table className="dashboard-table">
                            <thead>
                                <tr>
                                    <th>SL No</th>
                                    <th style={{ width: "auto" }}>List Name</th>
                                    <th className="received-on-col">
                                        <button
                                            type="button"
                                            className="sort-button"
                                            onClick={toggleSort}
                                        >
                                            <span>Received On</span>
                                            <span className={`sort-arrow ${sortOrder === "asc" ? "asc" : ""}`}></span>
                                        </button>
                                    </th>
                                    <th>CRM ID</th>
                                    <th className="data-count-col" style={{ width: "94px" }}>Data Count</th>
                                    {/* <th style={{ width: "160px" }}>Target Specifications</th> */}
                                    <th>Download File</th>
                                    <th>Data Refresh</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isListLoading && (
                                    <tr>
                                        <td colSpan={8} className="text-center py-3">
                                            <span className="spinner-border spinner-border-sm me-2" />
                                            Loading...
                                        </td>
                                    </tr>
                                )}
                                {!isListLoading && downloads.length === 0 && (
                                    <tr>
                                        <td colSpan={8} className="text-center py-3">
                                            No data requests found.
                                        </td>
                                    </tr>
                                )}

                                {downloads.map((item, index) => (
                                    <tr key={index}>
                                        <td>{String(index + 1).padStart(2, '0')}</td>
                                        <td>
                                            <EditableListName
                                                projectId={item.projectid}
                                                initialName={item.list_name ?? `File_${item.number_of_contacts}`}
                                                numberOfContacts={item.number_of_contacts}
                                                onSuccess={(newName) => {
                                                    setDownloads((prev) =>
                                                        prev.map((d) =>
                                                            d.projectid === item.projectid
                                                                ? { ...d, list_name: newName }
                                                                : d
                                                        )
                                                    );
                                                }}
                                            />
                                        </td>
                                        <td className="received-on-col">{item.created_at ? new Date(item.created_at).toISOString().split('T')[0] : '--'}</td>
                                        <td>{item.crm_id}</td>
                                        <td className="data-count-col">{Number(item.number_of_contacts).toLocaleString()}</td>
                                        {/* <td>
                                            <div className="d-flex flex-row justify-content-center">
                                                <div
                                                    className="page-icon"
                                                    onClick={() => openCriteriaPopup(item)}
                                                >
                                                    <img
                                                        src="/images/normal-page.png"
                                                        alt="normal"
                                                        className="icon-normal"
                                                    />
                                                    <img
                                                        src="/images/hovred-page.png"
                                                        alt="hover"
                                                        className="icon-hover"
                                                    />
                                                </div>
                                                <div>
                                                    <p className="dashboard-view">View</p>
                                                </div>
                                            </div>
                                        </td> */}
                                        <td>
                                            <div className="download-wrapper">
                                                <button
                                                    type="button"
                                                    className="downloade"
                                                    onClick={() => {
                                                        setSelectedItem(item);
                                                        setShowDownloadConfirm(true);
                                                    }}
                                                >
                                                    <img src="/images/download.png" style={{ width: "10px" }} alt="" />
                                                    Download
                                                </button>

                                                <div className="download-tooltip">
                                                    Click to download your <br /> verified data file.
                                                </div>
                                            </div>

                                        </td>
                                        <td>
                                            <div className="update-wrapper">
                                                {isOlderThan90Days(item.created_at) ? (
                                                    <>
                                                        <button
                                                            type="button"
                                                            className="update"
                                                            onClick={() => updateProject(item)}
                                                        >
                                                            {isLoading ? (<>
                                                                <span style={{ fontSize: "10px" }} className="spinner-border spinner-border-sm me-2" />
                                                                Processing...
                                                            </>
                                                            ) : (<><img src="/images/update.png" alt="update" />
                                                                <span>Update</span></>)}

                                                        </button>

                                                        <div className="update-tooltip">
                                                            Request the latest version<br /> of your dataset.
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <button
                                                            type="button"
                                                            className="updateafter-90"
                                                        >
                                                            After 90 days
                                                        </button>
                                                        <div className="update-tooltip">
                                                            Eligible for data refresh after<br />
                                                            90 days from delivery.
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="dashboard-pagination-wrapper">
                        <Pagination
                            page={pageDetail.page}
                            total_pages={pageDetail.total_pages}
                            total_records={pageDetail.total_records}
                            page_size={pageDetail.page_size}
                            onPageChange={(newPage) => loadPage(newPage)}
                        />
                    </div>
                    {/* download prepair popup */}
                    {showPopup && (
                        <div className="download-popup-overlay">
                            <div className="download-popup" style={{ width: "700px", maxWidth: "480px" }}>
                                <div className="d-flex flex-row justify-content-end">
                                    <div
                                        className="page-icon"
                                        onClick={() => setShowPopup(false)}
                                    >
                                        <img
                                            src="/images/close-inactive.png"
                                            alt="normal"
                                            className="icon-normal"
                                        />
                                        <img
                                            src="/images/close-active.png"
                                            alt="hover"
                                            className="icon-hover"
                                        />
                                    </div>

                                </div>
                                <div className='text-center'>
                                    <img src="/images/d-download.png" alt="" />
                                    <p className="popup-title">Your file is being prepared for download.</p>
                                    <p className="popup-text">
                                        This may take a few seconds.
                                    </p>
                                    <span className="spinner-border spinner-border-sm me-2" />
                                    <p className='popup-text'>Loading...</p>

                                </div>
                            </div>
                        </div>
                    )}
                    {/* download success popup */}
                    {showSuccessPopup && (
                        <div className="download-popup-overlay">
                            <div className="download-popup" style={{ width: "700px", maxWidth: "480px" }}>
                                <div className="d-flex flex-row justify-content-end">
                                    <div
                                        className="page-icon"
                                        onClick={() => setShowSuccessPopup(false)}
                                    >
                                        <img
                                            src="/images/close-inactive.png"
                                            alt="normal"
                                            className="icon-normal"
                                        />
                                        <img
                                            src="/images/close-active.png"
                                            alt="hover"
                                            className="icon-hover"
                                        />
                                    </div>

                                </div>
                                <div className='text-center'>
                                    <img src="/images/d-download.png" alt="" />
                                    <p className="popup-title">Download Completed Successfully</p>
                                    <p className="popup-text">
                                        Problem with the download? <a href="https://support.spokesly.com" target='_blank'>Let us know</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* update success popup */}
                    {showUpdatePopup && (
                        <div className="download-popup-overlay">
                            <div className="download-popup">
                                <div className="d-flex flex-row justify-content-end">
                                    <div
                                        className="page-icon"
                                        onClick={() => setShowUpdatePopup(false)}
                                    >
                                        <img
                                            src="/images/close-inactive.png"
                                            alt="normal"
                                            className="icon-normal"
                                        />
                                        <img
                                            src="/images/close-active.png"
                                            alt="hover"
                                            className="icon-hover"
                                        />
                                    </div>

                                </div>
                                <div className='text-center'>
                                    <img src="/images/hand-shak.png" alt="" />
                                    <p className="popup-title">Refresh Request Submitted!</p>
                                    <p className="popup-text">
                                        Our data team will update your list and notify you <br /> once the new version is ready.
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* criteria popup */}
                    {isOpen && (
                        <div
                            className="page-popup-overlay"
                            onClick={() => setIsOpen(false)}
                        >
                            <div
                                className="page-popup"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <div className="d-flex flex-row justify-content-end">
                                    <div>
                                        <img src="/images/close-active.png" alt="" style={{ cursor: "pointer" }} onClick={() => setIsOpen(false)} />
                                    </div>
                                </div>

                                <h4>Criteria</h4>

                                <div className="light-blue-box">

                                    <div className="row p-3">
                                        <div className="col-md-9" style={{ height: "400px", overflowY: "auto" }}>
                                            <div >
                                                {item?.industry && (
                                                    <p className="industry"><span style={{ fontWeight: "600" }}>Industry:</span> {item.industry}</p>
                                                )}

                                                {item?.technologies && (
                                                    <p className="industry"><span style={{ fontWeight: "600" }}>Technology Used:</span> {item.technologies}</p>
                                                )}

                                                {item?.geography && (
                                                    <p className="industry"><span style={{ fontWeight: "600" }}>Geography:</span> {item.geography}</p>
                                                )}

                                                {item?.company_size && (
                                                    <p className="industry"><span style={{ fontWeight: "600" }}>Company Size:</span> {item.company_size}</p>
                                                )}

                                                {item?.revenue_size && (
                                                    <p className="industry"><span style={{ fontWeight: "600" }}>Company Revenue:</span> {item.revenue_size}</p>
                                                )}

                                                {item?.job_title && (
                                                    <p className="industry"><span style={{ fontWeight: "600" }}>Job Titles:</span> {item.job_title}</p>
                                                )}

                                                {item?.data_fields && (
                                                    <p className="industry"><span style={{ fontWeight: "600" }}>Data Fields:</span> {item.data_fields}</p>
                                                )}

                                                {item?.other && (
                                                    <p style={{fontSize:"14px"}}><span style={{ fontWeight: "600" }}>Additional Requirement:</span>
                                                        <span
                                                            dangerouslySetInnerHTML={{
                                                                __html: item.other || "N/A"
                                                            }}
                                                        /></p>
                                                )}
                                            </div>
                                        </div>

                                        <div className="col-md-3 p-3">
                                            <div className="mb-3">
                                                <p className="date">Date Created</p>
                                                <p className="number-date">{item.created_at ? new Date(item.created_at).toISOString().split('T')[0] : '--'}</p>
                                            </div>
                                            <div className="mb-3">
                                                <p className="date">CRM ID</p>
                                                <p className="number-date">{item?.crm_id ?? '--'}</p>
                                            </div>
                                            <div>
                                                <p className="date">Counts</p>
                                                <p className="number-date">{Number(item?.number_of_contacts).toLocaleString() ?? '--'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* error popup */}
                    <Popup
                        isOpen={!!errorMsg}
                        onClose={() => setErrorMsg("")}
                        title={errorMsg}
                        iconSrc="/images/grey-cancel-cta.png"
                    />
                    {/* download csv or xlsxl popup */}
                    {showDownloadConfirm && (
                        <div className="download-popup-overlay">
                            <div className="download-popup">
                                <div className="d-flex justify-content-end">
                                    <img
                                        src="/images/close-active.png"
                                        alt="close"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setShowDownloadConfirm(false)}
                                    />
                                </div>

                                <div className="text-center">
                                    <div className="popup-title">Select file format</div>

                                    {/* Radio Buttons */}
                                    <div className="d-flex justify-content-center gap-4 my-3">
                                        <label className="d-flex align-items-center gap-2 popup-text" style={{ cursor: "pointer" }}>
                                            <input
                                                type="radio"
                                                name="downloadFormat"
                                                value="csv"
                                                checked={selectedFormat === "csv"}
                                                onChange={() => setSelectedFormat("csv")}
                                            />
                                            CSV
                                        </label>

                                        <label className="d-flex align-items-center gap-2 popup-text" style={{ cursor: "pointer" }}>
                                            <input
                                                type="radio"
                                                name="downloadFormat"
                                                value="xlsx"
                                                checked={selectedFormat === "xlsx"}
                                                onChange={() => setSelectedFormat("xlsx")}
                                            />
                                            XLSX
                                        </label>
                                    </div>

                                    <div className="download-wrapper">
                                        <button
                                            className="download"
                                            style={{ borderRadius: "4px" }}
                                            onClick={() => {
                                                setShowDownloadConfirm(false);
                                                downloadProject(selectedItem, selectedFormat);
                                            }}
                                        >
                                            Confirm Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default Dashboard;